import angular, {
  auto,
  IQService,
  ITemplateCacheService,
  IHttpService,
  IRootScopeService,
  ILogService,
  IWindowService,
  ISCEService,
  IIntervalService,
  IDocumentService,
  IFilterService,
  ITimeoutService,
  ICompileService,
} from 'angular'
import {
  StateService,
  StateParams,
  TransitionService,
} from '@uirouter/angularjs'
import { getFeatureFromCache } from '../util/feature-cache'
import { FEATURE_USE_NATIVE_Q } from '../constants/wr-features'
import { qNative } from './q-native'

// Checked ONCE at module load time — before server refreshes feature flags.
// try-catch handles test environments where a mock factory may reference an
// uninitialized outer variable during module evaluation, causing a TypeError.
let useNativeQ = false
try {
  useNativeQ = !!getFeatureFromCache(FEATURE_USE_NATIVE_Q)
} catch {
  // Default to false (Angular $q) if the feature flag can't be read yet
}

if (useNativeQ) {
  // Override Angular's built-in $q for all DI consumers in the module
  angular.module('webregister').constant('$q', qNative)
}

// AngularJS core
export let $compile: ICompileService
export let $document: IDocumentService
export let $filter: IFilterService
export let $http: IHttpService
export let $injector: auto.IInjectorService
export let $interval: IIntervalService
export let $log: ILogService
export let $q: IQService
export let $rootScope: IRootScopeService
export let $sce: ISCEService
export let $templateCache: ITemplateCacheService
export let $timeout: ITimeoutService
export let $window: IWindowService

// AngularJS Resource
export let $resource: any

// UI Router
export let $state: StateService
export let $stateParams: StateParams
export let $transitions: TransitionService

angular.module('webregister').run([
  '$injector',
  (i: auto.IInjectorService) => {
    $compile = i.get('$compile')
    $document = i.get('$document')
    $filter = i.get('$filter')
    $http = i.get('$http')
    $injector = i
    $interval = i.get('$interval')
    $log = i.get('$log')
    $q = useNativeQ ? ((qNative as unknown) as IQService) : i.get('$q')
    $rootScope = i.get('$rootScope')
    $sce = i.get('$sce')
    $templateCache = i.get('$templateCache')
    $timeout = i.get('$timeout')
    $window = i.get('$window')

    $resource = i.get('$resource')

    $state = i.get('$state')
    $stateParams = i.get('$stateParams')
    $transitions = i.get('$transitions')
  },
])
